import Hosts from '../../Hosts';

const object_type = 'intranet/suporte'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = companycode => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/suporte'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        cliente: [],
        colaborador: [],
        projeto: [],
        prioridade: [],
        assunto: '',
        solucao: [
            {},

        ],
        estado: false,
        datas: [{
            data_criacao: '',
            data_conclusao: '',
        }],        
    },
    addresses: [{
        village: '',
        city: '',
        type: [],
        region: '',
        country: '',
        apartado: '',
        localidade: '',
        contats: [],
        principal: '',
        observation: '',
        postal_code: '',
        street_name: '',
        address_detail: '',
    }],
    contacts: [{
        email: '',
        phone: '',
        principal: 'true',
        extensions: [],
        observation: '',
        mobile_phone: '',
        building_number: '',
    }],
    profile: { name: "Empresa" },
    notifications: []
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
